// extracted by mini-css-extract-plugin
export default {"list":"ProductsList_list__3BMYX","listItem":"ProductsList_listItem__aqQRf","loader":"ProductsList_loader__ZK-9l"};